import React, { useState, useEffect } from 'react'
import GenericFormHeaderComponent from '../../../../genericComponents/forms/GenericFormHeaderComponent';
import Icons from '../../../../assets/icons';
import ListComponent from '../../../../genericComponents/ListComponent';
import { useDispatch, useSelector } from 'react-redux';
import { CONFIG } from '../../../../config';
import { ChevronDown, ChevronRight, MoveRight } from 'lucide-react';
import GenericInput from '../../../../genericComponents/input/GenericInputComponent';
import GenericFormFooterComponent from '../../../../genericComponents/forms/GenericFormFooterComponent';
import { dispatchHandler } from '../../../../helper/apiHelperFunctions';
import GenericSpinnerLoader from '../../../../loaders/GenericSpinnerLoader';

const EditBoxIdModal = (props = {}) => {

    const dispatch = useDispatch();

    let { box = {}, permissionObj, poData = {}, isPoNonSet } = props;

    let [formData, setFormData] = useState({});

    const [expanededRow, setExpandedRow] = useState({});
    const updateBoxIdData = useSelector(state => state?.digivendStore?.updateBoxIdData);
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);

    // function: to expand the row
    const expandRow = (item) => {
        setExpandedRow({ ...expanededRow, [item?.["box_number"]]: !expanededRow?.[item?.["box_number"]] });
    }

    const getDataKey = () => {
        return isPoNonSet?.() ? "po_details_id" : "set_header_id"
    }

    useEffect(() => {
        if (updateBoxIdData?.["isSuccess"]) {
            props.refreshData();
            props.closeModal();
            props?.closeAsnModal();
        }
    }, [updateBoxIdData])

    // Function : to update the qty
    const updateQty = (payload) => {
        let { box_number, skuId, value, box, sku } = payload || {};
        let updatedFormData = { ...formData };

        if (!updatedFormData?.[box_number]) updatedFormData[box_number] = { box };
        if (!updatedFormData?.[box_number]?.[skuId]) updatedFormData[box_number][skuId] = {};
        updatedFormData[box_number][skuId] = {
            "qty": value,
            sku
        }

        setFormData(updatedFormData);
    }

    // fucntion : to get the qty for the sku
    const getQtyForTheSku = (payload) => {
        let { item, sku } = payload || {};
        let qty = formData?.[item?.["box_number"]]?.hasOwnProperty(sku?.[getDataKey?.()]) ? formData?.[item?.["box_number"]]?.[sku?.[getDataKey?.()]]?.["qty"] : sku?.["qty"];
        return qty;
    }

    // function: to render the skus
    const renderSkus = (item) => {
        return <div className='mb-4 rounded-[5px] border border-[#DAE4EE] '>
            <table className='w-full text-fontBlack'>
                <thead className='bg-[#F8F8F8] whitespace-nowrap sticky top-0 z-[1]'>
                    <tr className='border-b border-[#DAE4EE]'>
                        <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>{!isPoNonSet?.() ? "Set Barcode" : "Item Barcode"}</td>
                        <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>{!isPoNonSet?.() ? "Set Header Id" : "Item Code"}</td>
                        <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>Qty</td>
                    </tr>
                </thead>
                <tbody className='text-xs font-normal'>
                    {item?.["item_data"]?.length == 0 ? <tr colspan="100">
                        <p>No Data Found!</p>
                    </tr> : item?.["item_data"]?.map(sku => {
                        return <tr className='border-b last:border-b-0 border-[#DAE4EE]'>
                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE]'>{sku?.[isPoNonSet?.() ? "barcode" : "set_barcode"]}</td>
                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE]'>{sku?.[isPoNonSet?.() ? "itemcode" : "set_header_id"]}</td>
                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE]'>
                                <GenericInput
                                    genInputExtraClass='!mb-0'
                                    type="number"
                                    inputKey={`${item?.["box_number"]}-${sku?.[getDataKey?.()]}`}
                                    dependentFieldsObject={[`${item?.["box_number"]}-${sku?.[getDataKey?.()]}`]}
                                    value={getQtyForTheSku({
                                        item, sku
                                    })}
                                    onChange={(e) => {
                                        console.log("e-234", sku, getDataKey?.());
                                        updateQty({
                                            box_number: item?.["box_number"],
                                            skuId: sku?.[getDataKey?.()],
                                            value: e?.target?.value,
                                            box: item,
                                            sku: sku
                                        })
                                    }}
                                /></td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    // function : to render the form component
    const renderFormComponent = () => {
        if (!box?.["id"]) return (
            <div className='h-full w-full flex flex-col items-center justify-center gap-4'>
                <Icons.WarningYellowIcon className='shrink-0' />
                <p className='mb-0 text-[13px] font-medium text-fontBlack'>Box ID is not available!</p>
            </div>)


        if (step == 2) {
            return <div className='rounded-[5px] h-full overflow-auto border border-[#DAE4EE] '>
                <table className='w-full text-fontBlack'>
                    <thead className='bg-[#F8F8F8] whitespace-nowrap sticky top-0 z-[2]'>
                        <tr className='border-b border-[#DAE4EE]'>
                            <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>Box Number</td>
                        </tr>
                    </thead>
                    <tbody className='text-xs font-normal'>
                        {
                            Object.keys(formData || {})?.length == 0 ? <tr colspan={100}><td>No Data Found!</td></tr> : Object.keys(formData || {})?.map(key => (
                                <tr className='border-b last:border-b-0 border-[#DAE4EE]'>
                                    <td className='px-3 py-3 border-r last:border-r-0 border-[#DAE4EE]'>
                                        <p className='font-medium'>{key}</p>
                                        <div>
                                            {
                                                Object.keys(formData?.[key] || {})?.map(skuKey => {
                                                    return skuKey != "box" && <div className='mb-3 last:mb-0 rounded-[5px] border border-[#DAE4EE] overflow-auto'><table className='w-full text-fontBlack'>
                                                        <thead className='bg-[#F8F8F8] whitespace-nowrap sticky top-0 z-[1]'>
                                                            <tr className='border-b border-[#DAE4EE]'>
                                                                <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>{!isPoNonSet?.() ? "Set Barcode" : "Item Barcode"}</td>
                                                                <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>{!isPoNonSet?.() ? "Set Header Id" : "Item Code"}</td>
                                                                <td className='px-3 py-1.5 text-[#6A6C70] text-[11px] font-medium border-r last:border-r-0 border-[#DAE4EE]'>Qty</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE]'>{formData?.[key]?.[skuKey]?.["sku"]?.[isPoNonSet?.() ? "barcode" : "set_barcode"]}</td>
                                                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE]'>{formData?.[key]?.[skuKey]?.["sku"]?.[isPoNonSet?.() ? "itemcode" : "set_header_id"]}</td>
                                                            <td className='px-3 py-1.5 border-r last:border-r-0 border-[#DAE4EE] flex items-center gap-1.5'>{formData?.[key]?.[skuKey]?.["sku"]?.["qty"] || 0} <MoveRight size={13} /> <span className={`${(formData?.[key]?.[skuKey]?.["sku"]?.["qty"] < formData?.[key]?.[skuKey]?.["qty"] ? 'text-[#00891A]' : 'text-danger')}`}>{formData?.[key]?.[skuKey]?.["qty"] || 0}</span></td>
                                                        </tbody>
                                                    </table></div>
                                                })
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        }

        // render the loading animation here    
        // render the list component here
        return <ListComponent
            // modalMainClass="rs-bot !pt-[0]"
            useKeyboardShortcuts={false}

            // viewDataType={"table-view"}
            headerKeys={{
                "box_number": { value: "Box Number" },
            }}
            itemKeys={{
                "box_number": [(state, functions, item) => {
                    console.log("item-234", item);
                    return <div>
                        <div
                            onClick={() => {
                                expandRow(item);
                            }}
                            className='mb-3 flex items-center gap-2.5 cursor-pointer hover:opacity-75'
                        >
                            {/* {expanededRow?.[item?.["box_number"]] ? <ChevronDown color='black' /> : <ChevronRight color='black' />} */}
                            <div className={`duration-200 ${expanededRow?.[item?.["box_number"]] ? 'rotate-90' : 'rotate-0'}`}><ChevronRight size={18} /></div>
                            <p className='mb-0 text-[13px] font-medium text-fontBlack'>{item?.["box_number"]}</p>

                            {/* render tall the skus  */}
                        </div>
                        {expanededRow?.[item?.["box_number"]] && renderSkus(item)}
                    </div>
                }],
            }}
            search={{
                placeholder: `Search Box Number`,
                isSearchIconRequire: true,
            }}
            getListData={(data) => {
                return data?.resource || [];
            }}
            totalRecords={(data) => data?.apiAllData?.totalRecord || 0}
            api={{
                reduxState: 'generalStore',
                apiName: "getTableComponentFifthList",
                apiPayload: (params) => {
                    let { currentSearch, currentPage } = params || {};
                    return {
                        "shipmentAdviceCode": poData?.["shipmentAdviceCode"] || "",
                        "shipmentId": poData?.["shipmentId"] || "",
                        "box_id": box?.["id"] || "",
                        "pageNo": currentPage || 1,
                        "search": currentSearch || "",
                        "pageSize": 30,
                        "baseUrl": CONFIG.SM_BACKEND_BASE_URL,
                        "apiUrl": "/purchase/shipment/get/box/details"
                    }
                },
                apiExtraHeaders: permissionObj,
                getMaxPage: (states, functions, response) => {
                    return Number(response?.maxPage || "");
                },
            }}
        />
    }


    // Function : to handle the final submit 
    const handleSubmit = () => {
        if (step == 1) {
            setLoading(true);
            setStep(2);
            setTimeout(() => {
                setLoading(false)
            }, 1000)
            return;
        }

        if (step == 2) {
            console.log("formData-234", formData);
            let boxes = {}
            Object.keys(formData || {}).forEach(boxNumber => {
                let skus = [];
                Object.keys(formData?.[boxNumber] || {}).forEach(skuId => {
                    if (skuId != "box")
                        skus.push({
                            [getDataKey?.()]: skuId,
                            "qty": Number(formData?.[boxNumber]?.[skuId]?.["qty"])
                        })
                })
                if (!boxes?.[box?.["id"]]) boxes[box?.["id"]] = [];
                boxes[box["id"]].push({
                    "box_number": boxNumber,
                    "skus": skus,
                })
            })

            let updatedBoxes = [];
            Object.keys(boxes || {}).forEach(boxId => {
                updatedBoxes.push({
                    "box_id": boxId,
                    "boxes": boxes[boxId]
                })
            })

            dispatchHandler(dispatch, "updateBoxIdRequest", {
                "shipmentAdviceCode": poData?.["shipmentAdviceCode"] || "",
                "shipmentId": poData?.["shipmentId"] || "",
                "boxDetails": updatedBoxes,
            }, permissionObj)
        }
    }

    const isSomeQtyZeroOrNegative = () => {
        return Object.keys(formData || {}).some(boxNumber =>
            Object.keys(formData?.[boxNumber] || {}).some(skuId => {
                const item = formData?.[boxNumber]?.[skuId];
                if ('qty' in item) {
                    const qty = item.qty;
                    return qty === null || qty === undefined || qty === "" || qty <= 0;
                }
                return false;
            })
        );
    };

    const isReviewDisabled = () => {
        return  isSomeQtyZeroOrNegative() || Object.keys(formData || {})?.length == 0 || loading;
    }

    return (
        // Render the box id modla content here
        <div className='edit-box-id-modal h-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: "Edit Boxes",
                    contentSecondry: `Box ID : ${box?.["boxPrefix"]}/${box?.["id"] || "-"}`
                }}

                closeModal={props.closeModal}
            />
            <div className='px-[15px] h-full flex flex-col overflow-auto'>
                {!loading && renderFormComponent()}
            </div>

            {
                loading && <div className='flex justify-center items-center h-full w-full'>
                    <GenericSpinnerLoader />
                </div>
            }

            {/* render the finalsubit button */}
            <GenericFormFooterComponent
                buttons={[
                    {
                        type: "default",
                        onClick: step == 1 ? props.closeModal : () => setStep(1),
                        label: step == 1 ? 'Close' : 'Back'
                    },
                    {
                        type: "primary",
                        tooltip : isReviewDisabled() && isSomeQtyZeroOrNegative?.() && "Quantity for all SKUs must be greater than 0!",
                        label: step == 1 ? "Review" : "Confirm",
                        disabled: step == 1 ? isReviewDisabled() : loading || false,
                        onClick: handleSubmit,
                    }
                ].filter(Boolean)}
            />
        </div>
    )
}

export default EditBoxIdModal;